(() => {
  if (window.__unikcosaAtelier) return;
  window.__unikcosaAtelier = true;

  const root = document.documentElement;
  root.classList.add('uk-at-js');

  const reveal = () => {
    const elements = Array.from(document.querySelectorAll('[data-uk-reveal]:not(.is-visible)'));
    if (!elements.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });

    elements.forEach((element) => observer.observe(element));
  };

  const setHeaderState = () => {
    root.classList.toggle('uk-at-scrolled', window.scrollY > 18);
  };

  const bindSortSelects = () => {
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      if (select.dataset.ukAtBound === 'true') return;
      select.dataset.ukAtBound = 'true';
      select.addEventListener('change', () => select.form?.submit());
    });
  };

  const boot = () => {
    reveal();
    setHeaderState();
    bindSortSelects();
  };

  document.addEventListener('DOMContentLoaded', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('scroll', setHeaderState, { passive: true });
})();
